import { styled } from '@/stitches.config';
import { ReactComponent as Visibility } from '@assets/icons/visibility.svg';
import { ReactComponent as VisibilityOff } from '@assets/icons/visibility-off.svg';
import { Box } from '@base-app';

export const FlexBoxStyled = styled(Box, {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'flex-top',
});

export const VisibilityIconStyled = styled(Visibility, {
  color: '$darkGray200',
  height: '$6',
  width: '$6',
  '&:hover': {
    cursor: 'pointer',
  },
});

export const VisibilityOffIconStyled = styled(VisibilityOff, {
  color: '$darkGray200',
  height: '$6',
  width: '$6',
  '&:hover': {
    cursor: 'pointer',
  },
});

export const VisibilityContainerStyled = styled(Box, {
  paddingTop: '$6',
  marginLeft: '-$6',
});

export const DescriptionStyled = styled('p', {
  color: '$darkGray200',
  fontSize: '$xs',
  fontWeight: '$medium',
  mb: '$0',
  mt: '$0',
});
